<div class="benefits">
  <div class="benefits-top-block container">
    <p class="top-block-title">Benefits</p>
    <p class="top-block">Staking your CGU tokens is a great way to earn ongoing rewards and contribute to the growth
      of
      CGU ecosystem</p>
  </div>
  <div class="benefits-bottom-block">
    <div class="bottom-block-left">
      <img class="benefits-image-rocket" src="/static/images/benefits/rocket_2.webp" alt="">
    </div>
    <div class="bottom-block-right">
      <div class="bottom-block-right-container">
        <p class="block-title">Ongoing rewards</p>
        <p class="block-text">CGU tokens are bought from the open market using a proportion of revenues generated from
          CGU's NFT lending and gamer income. These tokens are held in a designated wallet and distributed weekly to
          users who lock their CGU in the staking contract.</p>
      </div>
      <div class="bottom-block-right-container">
        <p class="block-title">Benefits for CGU token holders</p>
        <p class="block-text">We will be introducing a range of other benefits for staking your CGU tokens, in line
          with
          services provided within our ecosystem, and regularly updated via community votes.</p>
      </div>
    </div>
  </div>
</div>
